import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GA4Tracker = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadGA4 = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/settings/ga4-tracking`);
        
        if (response.data.enabled && response.data.measurement_id) {
          const measurementId = response.data.measurement_id;
          
          // Check if already loaded
          if (window.gtag) {
            setLoaded(true);
            return;
          }
          
          // Load Google Analytics script
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
          document.head.appendChild(script);
          
          // Initialize gtag
          script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              window.dataLayer.push(arguments);
            }
            window.gtag = gtag;
            gtag('js', new Date());
            gtag('config', measurementId);
            setLoaded(true);
            console.log('GA4 tracking initialized:', measurementId);
          };
        }
      } catch (error) {
        // Silently fail - GA4 tracking is optional
        console.log('GA4 tracking not configured');
      }
    };

    loadGA4();
  }, []);

  return null; // This component doesn't render anything
};

export default GA4Tracker;
